import React, { useState } from 'react';
import useStore from '../store/store';
import ToolTipIcon from './ToolTipIcon'
import { Row, Col } from 'react-grid-system';
const Controllers = (e) => {


	// Note: 
	// This controls the store in order to produce 4 different states:
	//
	// measuredDB
	// measuredOCTAVES
	// soundPowerOCTAVES
	// soundPowerDB

	// These represent the 4 different panels underneath the tool.

	const setScenario = useStore((state) => state.setScenario);
	const scenario = useStore((state) => state.scenario);
	const grid = useStore((state) => state.grid);
	const setGrid = useStore((state) => state.setGrid);
	const [selectedOption, setSelectedOption] = useState('DB');
	// display either measured or sound power panel
	const currentActivePanel = useStore((state) => state.activePanel);
	const setActivePanel = useStore((state) => state.setActivePanel);
	// Display either dB(A) Only or Octave Bands
	const currentactiveDBorOctavePanel = useStore((state) => state.activeDBorOctavePanel);
	// internal state for DBorOctave dropdown
	const setActiveDBorOctavePanel = useStore((state) => state.setActiveDBorOctavePanel);
	const activeDBorOctavePanel = useStore((state) => state.activeDBorOctavePanel);


	function onChange(e) {
		const value = e.target.value;
		setScenario(value);
	}

	function onGridChange(e) {
		const value = e.target.value;
		setGrid(value);
	}

	function updatePanel(value) {
		setActivePanel(value)

		// Update bottom panels when clicking in top buttons as well - a bit hacky now but works

		if (value === 'measured') {
			const currentPanel = value + currentactiveDBorOctavePanel.split("soundPower").pop();
			setActiveDBorOctavePanel(currentPanel);
		}

		if (value === 'soundPower') {
			const currentPanel = value + currentactiveDBorOctavePanel.split("measured").pop();
			setActiveDBorOctavePanel(currentPanel);
		}

	}

	function updateDbOrOcatave(value) {
		const computedResult = currentActivePanel + value;
		setSelectedOption(value)
		setActiveDBorOctavePanel(computedResult);
	}

	const BarriersDropDown = () => {
		return (
			<div id="barriersDropDown">
				<label style={{ display: 'flex', flexFlow: 'row', alignItems: 'center' }}>
					<h2>Barriers</h2>
					<ToolTipIcon
						toolTipMessage={'Calculate the receiver noise level with: Single Barrier in place; Double Barrier - 2 barriers in place; Building – a simple building in place as a barrier. '}
						isToolTipMessage
					></ToolTipIcon>
				</label>
				<select onChange={(e) => onChange(e)} name="barriers" value={scenario}>
					<option value="noBarriers">No Barriers</option>
					<option value="singleBarrier">Single Barrier</option>
					<option value="doubleBarrier">Double Barrier</option>
					<option value="building">Building</option>
				</select>
			</div>
		)
	}

	const DisplayDropDown = () => {
		return (
			<div id="displayDropDown" style={{ marginLeft: '10px' }}>
				<label htmlFor="Display"><h2>Display</h2></label>
				<select onChange={(e) => onGridChange(e)} name="grid" value={grid}>
					<option value="distance">Distance (m)</option>
					<option value="grid">Grid (m)</option>
					<option value="noGrid">Off</option>
				</select>
			</div>
		)
	}

	const DBorOctaveDropDown = () => {

		const selectedOption = ['soundPowerOCTAVES', 'measuredOCTAVES'].includes(activeDBorOctavePanel) ? 'OCTAVES' : 'DB';
		return (
			<div id="soundPowerTypeDropDown" style={{ width: '100%' }}>
				<select style={{ width: '100%' }} defaultValue={selectedOption} onChange={(e) => updateDbOrOcatave(e.target.value)} >
					<option value="DB">dB(A) Only</option>
					<option value="OCTAVES">Octave bands</option>
				</select>
			</div>
		)
	}

	const NoiseDataButton = ({ title, setActivePanel, isActive, toolTip, style }) => {
		return (

			<button disabled={isActive} className='topToolButtons' onClick={(value) => { setActivePanel(value) }} style={{
				backgroundColor: `${isActive ? '#ef7521' : 'white'}`,
				color: `${isActive ? 'white' : 'grey'}`,
				border: `${isActive ? 'none' : '1px solid grey'}`,
				padding: '5px',
				borderRadius: '5px',
				width: '100%',
				...style
			}}
			>
				{title}
			</button>

		)
	}

	const NoiseData = () => {
		return (
			<div id="toolTipsAndHeadings">
				<label style={{ display: 'flex', flexFlow: 'row', alignItems: 'center' }}>
					<h2>Noise Data</h2>
					<ToolTipIcon
						isLeft={true}
						toolTipMessage={'Note: if there are reflecting surfaces within a few meters of the source when you measure, then the noise level will be increased slightly compared with measurements made in the open.'}
					></ToolTipIcon>
				</label>
				<div style={{ display: 'flex', flexFlow: 'row' }}>
					<NoiseDataButton
						title='Measured'
						setActivePanel={() => updatePanel('measured')}
						isActive={currentActivePanel === 'measured'}
					/>
					<NoiseDataButton
						title='Sound Power'
						setActivePanel={() => updatePanel('soundPower')}
						isActive={currentActivePanel === 'soundPower'}
						style={{ marginLeft: '10px' }}
					/>
				</div>
				<div style={{ marginTop: '10px' }}>
					<DBorOctaveDropDown />
				</div>
			</div>
		)
	}

	return (
		<div className="topTools" id="topTools">
			<Col xs={6} md={6} lg={4}>
				<BarriersDropDown />
			</Col>
			<Col xs={6} md={6} lg={4}>
				<DisplayDropDown />
			</Col>
			<Col xs={12} sm={12} md={12} lg={4}>
				<NoiseData />
			</Col>
		</div>
	)
}

export { Controllers };